import React from 'react';
import {disableBodyScroll, enableBodyScroll} from "body-scroll-lock";

class BodyScrollLocker extends React.Component {

    constructor(props) {
        super(props);
        this.scrollContainer = null;
    }

    componentDidUpdate(prevProps) {
        if (prevProps.enabled !== this.props.enabled && this.scrollContainer) {
            if (this.props.enabled) {
                disableBodyScroll(this.scrollContainer);
            } else {
                enableBodyScroll(this.scrollContainer);
            }
        }
    }
    
    componentWillUnmount() {
        if(this.scrollContainer) {
            enableBodyScroll(this.scrollContainer);   
        }
    }

    setScrollContainer = (element) => {
        if(this.scrollContainer) {
            enableBodyScroll(this.scrollContainer); 
        }
        
        this.scrollContainer = element;
        
        if (this.props.enabled) {
            disableBodyScroll(this.scrollContainer);
        } else {
            enableBodyScroll(this.scrollContainer);
        }
    };

    render() {
        const {children, ...props} = this.props;
        return <div ref={this.setScrollContainer} {...props}>
            {children}
        </div>
    }
}

export default BodyScrollLocker;
